var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 60,
    viewBox: "0 0 123 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.5 55C75.3071 55 86.5 43.8071 86.5 30C86.5 16.1929 75.3071 5 61.5 5C47.6929 5 36.5 16.1929 36.5 30C36.5 43.8071 47.6929 55 61.5 55Z",
    fill: "#B60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1496 30.0016L71.5746 22.5766C72.2996 21.8516 72.2996 20.6516 71.5746 19.9266C70.8496 19.2016 69.6496 19.2016 68.9246 19.9266L61.4996 27.3516L54.0746 19.9266C53.3496 19.2016 52.1496 19.2016 51.4246 19.9266C50.6996 20.6516 50.6996 21.8516 51.4246 22.5766L58.8496 30.0016L51.4246 37.4266C50.6996 38.1516 50.6996 39.3516 51.4246 40.0766C51.7996 40.4516 52.2746 40.6266 52.7496 40.6266C53.2246 40.6266 53.6996 40.4516 54.0746 40.0766L61.4996 32.6516L68.9246 40.0766C69.2996 40.4516 69.7746 40.6266 70.2496 40.6266C70.7246 40.6266 71.1996 40.4516 71.5746 40.0766C72.2996 39.3516 72.2996 38.1516 71.5746 37.4266L64.1496 30.0016Z",
    fill: "#B60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.01d32bbdadefd801109a45c38ab65e79.svg";
export { ForwardRef as ReactComponent };